import { render } from "./PDFSamples.vue?vue&type=template&id=a797a042&ts=true"
import script from "./PDFSamples.vue?vue&type=script&lang=ts"
export * from "./PDFSamples.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__